module.exports = __webpack_public_path__ + "media/images/design/images/bn_npo-8750a789c71d4d06f7ba44258ecea43c.jpg";